import { PagingResultsViewModel, EnumSiNoTodos, FilterSearchingBaseViewModel } from '../../../core/_infrastructure/types/common';
import { TUbicacionViewModel } from '../puntosinspeccion/puntoinspeccion.types';

export class UbicacionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TUbicacionViewModel[];
}

export class FilterSearchingTUbicacionViewModel extends FilterSearchingBaseViewModel {
    public Id: number;
    public IdPuntoInspeccion: number | null = null;
    public Descripcion: string = '';
    public HabilitadaImportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadaExportacion: number = EnumSiNoTodos.TODOS;
    public PorDefecto: number = EnumSiNoTodos.TODOS;
}
